// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-pill-group {
  overflow: hidden;
}
.bolt-pill-group.overflow-wrap > .bolt-pill-group-inner {
  flex-wrap: wrap;
}
.bolt-pill-group.overflow-wrap > .bolt-pill-group-inner .bolt-pill {
  margin-bottom: 8px;
}
.bolt-pill-group.overflow-fade {
  mask-image: linear-gradient(to left, rgba(0, 0, 0, 0), rgba( 0, 0, 0 ,  1 ) 30px);
  mask-image: linear-gradient(to left, rgba(0, 0, 0, 0), rgba( var(--palette-neutral-100,0, 0, 0) ,  1 ) 30px);
  -webkit-mask-image: -webkit-linear-gradient(right, rgba(0, 0, 0, 0), rgba( 0, 0, 0 ,  1 ) 30px);
  -webkit-mask-image: -webkit-linear-gradient(right, rgba(0, 0, 0, 0), rgba( var(--palette-neutral-100,0, 0, 0) ,  1 ) 30px);
}

.bolt-pill-group-inner > :not(:last-child) {
  margin-right: 8px;
}

/*# sourceMappingURL=PillGroup.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/PillGroup/PillGroup.scss","webpack://./../azure-devops-ui/bin/Components/PillGroup/PillGroup.css"],"names":[],"mappings":"AACA;EACI,gBAAA;ACAJ;ADEI;EACI,eAAA;ACAR;ADCQ;EACI,kBAAA;ACCZ;ADGI;EACI,iFAAA;EACA,4GAAA;ECDN,+FAA+F;EAC/F,0HAA0H;ADI5H;;ACDA;EACE,iBAAiB;AACnB;;AAEA,wCAAwC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
